import * as ApiRequests from '../../api/requests';
import { AuthHelper } from '../../types/auth-helper-types';
import { AppThunk } from '../actions';
import { ResetSuggestionActions } from '../actions/reset-suggestion-actions';
export const ResetSuggestionThunks = {
    ResetUserSuggestionForm: (alarmId: string, deviceId: string, authHelper: AuthHelper,addToast: Function): AppThunk => async (
        dispatch
    ): Promise<void> => {
        dispatch(ResetSuggestionActions.resetUserSuggestionStarted());

        const payload = await ApiRequests.ResetUserSuggestionForm(
            { alarmId: alarmId, deviceId: deviceId },
            { authHelper }
        );     
        if (payload.ok) {
            dispatch(
                ResetSuggestionActions.resetUserSuggestionSucceeded()
            );
        } else {
            addToast(ApiRequests.extractResponseNotOkMessage(payload.response), 'error');
            dispatch(ResetSuggestionActions.resetUserSuggestionFailed(`${ApiRequests.extractResponseNotOkCode(payload.response)}`));
        }
    }
};
